import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { RouteComponentProps, RouteProps } from 'react-router';
import { useSelector } from 'src/client/redux';
import { useJoinUrl } from '../components/buttons/JoinButton';

type Props = Omit<RouteProps, 'component'> & {
  campaign?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ElementType<RouteComponentProps<any>>;
  requiresAuth?: boolean;
  redirectLocation: string;
  validationFn: (routeProps: RouteComponentProps<{ sortBy?: string; page?: string }>) => boolean;
  disabled?: boolean;
  disabledRedirectLocation?: string;
};

export const GuardedRoute = (props: Props) => {
  const {
    campaign = 'unauthorized-route',
    component: Component,
    disabled,
    disabledRedirectLocation,
    requiresAuth,
    redirectLocation,
    validationFn,
    ...rest
  } = props;
  const { user, loaded: userLoaded } = useSelector((state) => state.auth);
  const [joinUrl] = useJoinUrl({ campaign });

  if (disabled) return <Redirect to={disabledRedirectLocation || '/'} />;

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (requiresAuth && !userLoaded) return null;

        if (requiresAuth && !user) return <Redirect to={joinUrl} />;

        if (!validationFn(routeProps)) return <Redirect to={redirectLocation as string} />;

        return <Component {...routeProps} />;
      }}
    />
  );
};
